
import AddFileIcon from '../../../assets/icons/AddFileIcon'
import styled from 'styled-components'
import FileIcon from '../../../assets/icons/FileIcon'
import StyledText from '../../../components/StyledComponents/StyledText'
import DownloadIconNoBg from '../../../assets/icons/DownloadIconNoBg'
import { CorporateTheme, Theme } from '../../../utils/themes'
import { Button } from '../../../components/form/Button'
import { useTheme } from '../../../middleware/ThemeContext'
import AddIcon from '../../../assets/icons/AddIcon'
import { ErrorMessage, Form, Formik } from 'formik'
import FormikFileUpload from '../../../components/Formik/FormikFileUpload'
import { useCreateImportMutation, useDocumnetPreSignedUrlMutation, useDownloadSampleFileMutation } from '../../../api/contactApiSlice'
import { useToast } from '../../../components/toast/ToastContext'
import { useNavigate } from 'react-router-dom'
import { LoadingSpinner } from '../../ui/LoadingSpinner'
import * as Yup from "yup";
import { useState } from 'react'

const DropFile = ({ scope, selectedOption, setHasUploaded, hasUploaded, onClose }: { scope: string, selectedOption: string, setHasUploaded: (state: boolean) => void, hasUploaded: boolean, onClose: () => void }) => {
    const [documnetPreSignedUrl] = useDocumnetPreSignedUrlMutation();
    const [downloadSample, { isLoading: isDownloadingSample }] = useDownloadSampleFileMutation();
    const [createImport, { isLoading }] = useCreateImportMutation();
    const { theme } = useTheme();
    const showToast = useToast();
    const navigate = useNavigate();
    const [fileNameErr, setFileNameErr] = useState<string>('');
    const [isUploading, setIsUploading] = useState(false);
    interface UploadedFile {
        file: File;
        name: string;
        type: string;
        rename: string;
        progress: number;
    }
    const handleUpload = async (file: UploadedFile): Promise<{ key: string }> => {

        setHasUploaded(true);
        setIsUploading(true);
        const parts = file.name?.split(".");
        const extension = parts.pop();
        const { data } = await documnetPreSignedUrl({
            fileName: file.name,
            fileType: extension,
            scope: scope,
            importType: selectedOption,
        });

        if (!data?.url) {
            showToast("Error",
                'Could not process the upload. Please make sure the file is valid and the internet connection is stable', "error"
            );
            setIsUploading(false);
            return { key: '' };
        }

        // Upload the file to the pre-signed URL
        // await fetch(data?.url, {
        //     method: data?.method,
        //     headers: {
        //         Accept: 'application/json',
        //         'Content-Type': file.type,
        //     },
        //     body: file.file,
        // });
        // return { key: data?.key };



        // For Progress
        return new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest();
            xhr.open(data.method, data.url, true);
            xhr.setRequestHeader("Content-Type", file.type);

            xhr.upload.onprogress = (event) => {
                if (event.lengthComputable) {
                    const percent = Math.round((event.loaded / event.total) * 100);
                    const progressEvent = new CustomEvent("file-upload-progress", {
                        detail: {
                            name: file.name,
                            progress: percent,
                        },
                    });
                    window.dispatchEvent(progressEvent);
                }
            };

            xhr.onload = () => {
                setIsUploading(false);
                if (xhr.status === 200 || xhr.status === 204) {
                    resolve({ key: data.key });
                } else {
                    reject(new Error("Upload failed"));
                }
            };

            xhr.onerror = () => {
                setIsUploading(false);
                reject(new Error("Upload error"));
            };

            xhr.send(file.file);
        });
    };


    const handleSubmit = (values: any) => {
        const fileObject = values?.file?.file;

        if (!fileObject?.file?.name) {
            setFileNameErr("File is required");
            return;
        }

        if (!fileObject?.rename?.trim()) {
            setFileNameErr("File name is required");
            return;
        }

        setFileNameErr("");

        if (!fileObject || !fileObject.name) {
            console.error("Invalid file");
            return;
        }

        const parts = fileObject.name.split(".");
        const extension = parts.pop();


        const payload = {
            originalFileName: fileObject?.file?.name,
            fileName: fileObject?.rename,
            fileSize: fileObject?.file?.size,
            fileType: extension,
            fileKey: values?.file?.key,
            scope: scope, // assumed from component state
            importType: selectedOption // assumed from UI
        };

        createImport(payload)
            .then((response) => {
                if (response?.error) {
                    // showToast("Failed", response?.error?.data?.message, "error");
                    if ('data' in response.error) {
                        const message = (response.error.data as { message?: string })?.message || "Something went wrong";
                        showToast("Failed", message, "error");
                    }

                } else {
                    onClose();
                    // navigate(`/home/mapping/${response?.data?.importData?.id}`, {
                    //     state: { scopeId: response?.data?.importData?.scopeId }
                    // });
                    navigate(`/home/mapping/${response?.data?.importData?.id}/${response?.data?.importData?.scopeId}`);
                }


            })
            .catch((error) => {
                console.error("Upload failed:", error);
                showToast("Failed", "Failed to import data", "error");
                // Show error message to user
            });



    };

    const downloadSampleFile = async () => {

        try {
            const blob = await downloadSample({ scope, importType: selectedOption }).unwrap();
            // Create a temporary URL
            const url = window.URL.createObjectURL(blob);

            // Create <a> tag for download
            const link = document.createElement("a");
            link.href = url;
            link.download = "sample-file.xlsx"; // filename set karo
            document.body.appendChild(link);
            link.click();

            // Cleanup
            link.remove();
            window.URL.revokeObjectURL(url);

        } catch (err) {
            console.error("Download failed", err);
        }
        // download sample file
    };

    return (
        <div>
            <Formik
                initialValues={{
                    file: [],
                }}
                enableReinitialize
                // validationSchema={setScopeSchema}
                onSubmit={handleSubmit}
            >
                {({ handleSubmit, values }) => (

                    <Form onSubmit={handleSubmit}>
                        <FormikFileUpload icon={<AddFileIcon />} showRenameInput={true} name='file' onUpload={handleUpload} setHasUploaded={setHasUploaded} checkError={fileNameErr} />
                        {hasUploaded ? null : <StyledSampleFile theme={theme}>
                            <div className='d-flex gap-3 pe-4'>
                                <div>
                                    <FileIcon />
                                </div>
                                <div>
                                    <StyledText fontWeight={600} fontSize='16px'>
                                        Sample Format
                                    </StyledText>
                                    <StyledText className='mt-1' fontWeight={400} fontSize='14px' textColor={theme.CorporateTheme.colors.textSecondary} lineHeight='20px'>
                                        Use this template to ensure your column headers and
                                        formatting match system expectations. We recommend
                                        starting with this file for smooth imports.
                                    </StyledText>
                                </div>
                            </div>
                            <div className='d-flex flex-column align-items-center justify-content-center' onClick={() => { if (!isDownloadingSample) downloadSampleFile() }}>
                                <StyledDownloadButton theme={theme}>
                                    {isDownloadingSample ? <LoadingSpinner color={theme.CorporateTheme.colors.textPrimary} size='20px' /> : <DownloadIconNoBg color={theme.CorporateTheme.colors.textPrimary} />}
                                </StyledDownloadButton>
                                <StyledText fontWeight={400} fontSize='12px' textColor={theme.CorporateTheme.colors.textSecondary} className='mt-1' >Excel</StyledText>
                            </div>
                        </StyledSampleFile>}
                        <Button 
                            className='w-100 mt-3' 
                            theme={theme} 
                            borderColor={theme.CorporateTheme.colors.primary} 
                            type="submit" 
                            $variant="customButton" 
                            fontSize="12px" 
                            height="42px" 
                            color={theme.CorporateTheme.colors.background} 
                            btnBg={theme.CorporateTheme.colors.primary} 
                            onClick={() => { }}
                            disabled={isUploading || isLoading ? true : false}
                        >
                            {isLoading ? <LoadingSpinner color={theme.CorporateTheme.colors.background} size='20px' /> : <AddIcon color={theme.CorporateTheme.colors.background} />} Continue Import
                        </Button>
                    </Form>
                )}
            </Formik>
        </div>
    )
}

const StyledSampleFile = styled.div<{ theme: Theme }>`
  background-color: ${({ theme }) => theme.CorporateTheme.colors.filterBG};
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
  padding: 30px 40px;
  margin-top: 20px;
  border: 1px solid ${CorporateTheme.colors.border};
`;

const StyledDownloadButton = styled.button<{ theme: Theme }>`
  background-color: ${({ theme }) => theme.CorporateTheme.colors.background};
  color: #fff;
  border: none;
  padding: 5px 10px;
  border-radius: 22px;
  cursor: pointer;
  height: 44px;
  width: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export default DropFile
